
import { DesignerOptions } from '@r-core';
import { Island } from '@rta/rta-blueprint-library';

export type ShowCountertopDilProps = {
	island: Island;
	options: DesignerOptions;
	offsetX?: number;
	offsetY?: number;
};

export const showCountertopDil = (props: ShowCountertopDilProps): Record<string, React.ReactElement> => {
	const { island, options } = props;
	const dil = {
		cornerPoints: <></>,
		connectionPoints: <></>,
		islandOrigin: <></>
	};

	// don't show developer insights
	if (!options.showDeveloperInsights) return dil;

	const d = [];
	const e = [];
	island.panels.children.forEach((panel, i) => {
		const { corners: p1, center: c1 } = panel.getCornerPoints(true, { nearestSixteenth: true, translate: true, rotate: true, lock: true });
		const { corners: p2, center: c2 } = panel.getCornerPoints(null, { nearestSixteenth: true, translate: true, rotate: true, lock: true });
		const { corners: p3, center: c3 } = panel.getCornerPoints(false, { nearestSixteenth: true, translate: true, rotate: true, lock: true });
		d[i] = { i: { c: c1, o: p1 }, o: { c: c3, o: p3 }, m: { c: c2, o: p2 }};

		const { corners: p4, center: c4 } = panel.getSidePoints({ nearestSixteenth: true, translate: true, rotate: true });
		e[i] = { o: { c: c4, o: p4 }};
	});


	dil.cornerPoints = <>
		<g fill="lightgrey" stroke="black" strokeWidth=".0625" strokeDasharray="2 .5" opacity={options.showCountertops ? 0.25 : 0.75}>
			{ d.map((p, i) => {
				return <g key={i}>
					// inside corner points
					<circle cx={p.i.o[0].x} cy={p.i.o[0].z} r=".25" fill="yellow" />
					<circle cx={p.i.c.x} cy={p.i.c.z} r=".25" fill="yellow" />
					<circle cx={p.i.o[1].x} cy={p.i.o[1].z} r=".25" fill="yellow" />

					// middle corner points
					<circle cx={p.m.o[0].x} cy={p.m.o[0].z} r=".25" fill="yellow" />
					<circle cx={p.m.c.x} cy={p.m.c.z} r=".25" fill="yellow" />
					<circle cx={p.m.o[1].x} cy={p.m.o[1].z} r=".25" fill="yellow" />

					// outside corner points
					<circle cx={p.o.o[0].x} cy={p.o.o[0].z} r=".25" fill="yellow" />
					<circle cx={p.o.c.x} cy={p.o.c.z} r=".25" fill="yellow" />
					<circle cx={p.o.o[1].x} cy={p.o.o[1].z} r=".25" fill="yellow" />
				</g>;
			})}
			{ e.map((p, i) => {
				return <g key={i}>
					// outside side points
					<circle cx={p.o.o[0].x} cy={p.o.o[0].z} r=".15" fill="blue" />
					<circle cx={p.o.c.x} cy={p.o.c.z} r=".15" fill="blue" />
					<circle cx={p.o.o[1].x} cy={p.o.o[1].z} r=".15" fill="blue" />
				</g>;
			})}
		</g>
	</>;

	dil.connectionPoints = <g>
		{ island.connections.children.filter((c) => !c.isSource)
			.map((c, i) => {
				const p1 = c.getSourcePoint();
				return <g key={i}>
					<circle cx={p1.x} cy={p1.z} r="0.5" fill="red" strokeWidth={0.125} opacity={0.5}/>
					<circle cx={p1.x} cy={p1.z} r="0.35" fill="green" strokeWidth={0.125} opacity={0.5}/>
				</g>
			})
		}

		{ island.connections.getSourceConnections()
			.map((c, i) => {
				const p1 = c.getSourcePoint();
				return <g key={i}>
					<circle cx={p1.x} cy={p1.z} r="0.5" fill="green" strokeWidth={0.125} opacity={0.5}/>
					<circle cx={p1.x} cy={p1.z} r="0.35" fill="red" strokeWidth={0.125} opacity={0.5}/>
				</g>
			})
		}
	</g>;

	dil.islandOrigin = <g>
		{ /* debug: orange = Island Origin */ }
		<circle cx={0} cy={0} r=".125" fill="orange" />
		<line x1={-100} y1="0" x2={100} y2="0" stroke="orange" strokeWidth=".1" strokeDasharray=".25"/>
		<line x1="0" y1={-100} x2="0" y2={100} stroke="orange" strokeWidth=".1" strokeDasharray=".25" />

		{ /* debug: Blue = Counter Origin */ }
		{/* <circle cx={xOriginShift} cy={yOriginShift} r=".6" fill="blue" /> */}
	</g>;

	return dil;
};
